// extracted by mini-css-extract-plugin
export default {"customWidth":"zY7Kd8Jwy2yiu9IVNGI9"};